import { actionAddException } from 'react-redux-app/lib/modules/exception/actions';
import {
  actionLoadGridDataRequest,
  actionLoadGridDataSuccess,
  actionLoadGridDataFail,
} from 'react-redux-app/lib/modules/grid/actions';
import { actionAddPayoutRequests } from './payoutRequests';

import { PAYOUT_REQUESTS_GRID_NAME, payoutStatuses } from '../constants';
import { PAYOUT_REQUESTS_SCHEMA } from '../schemas';

import { removeBlankFields } from 'react-redux-app/lib/modules/core/utils';
import { getGridFilter } from '../utils/payoutRequests';


export const actionLoadPayoutRequestsRequest = () => (
  (dispatch, getState, { apiClientHelper, history: { location } }) => {
    dispatch(actionLoadGridDataRequest(PAYOUT_REQUESTS_GRID_NAME));

    const filter = getGridFilter(location);

    const newFilter = {
      ...filter,
      status: !filter.status || filter.status.length === payoutStatuses.length
        ? null
        : filter.status,
    };

    return apiClientHelper.get(
      '/rest/webmaster/payout_request',
      { params: removeBlankFields(newFilter) },
      PAYOUT_REQUESTS_SCHEMA
    ).then(
      ({ entities, result }) => {
        dispatch(actionAddPayoutRequests(entities.payoutRequests));

        dispatch(actionLoadGridDataSuccess(
          PAYOUT_REQUESTS_GRID_NAME, result.items, result.count, result.summary
        ));
      },
      error => {
        dispatch(actionLoadGridDataFail(PAYOUT_REQUESTS_GRID_NAME, error));
      }
    ).catch(error => {
      dispatch(actionAddException(error));
    });
  }
);
